"use client";

import { useOrganization } from "@clerk/nextjs";
import { OrganizationAvatarOrPlaceholder } from "./organization-avatar";

const OrganizationButton = ({ className }: { className?: string }) => {
  const { organization } = useOrganization();

  return (
    <OrganizationAvatarOrPlaceholder
      name={organization?.name}
      imageUrl={organization?.imageUrl}
      className={className}
    />
  );
};

export default OrganizationButton;
